import { axios } from '@/utils/request'

/**
 * 查询优惠券
 *
 * @author zhangjw
 * @date 2023-06-16 09:50:35
 */
export function buCouponPage (parameter) {
  return axios({
    url: '/buCoupon/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 优惠券列表
 *
 * @author zhangjw
 * @date 2023-06-16 09:50:35
 */
export function buCouponList (parameter) {
  return axios({
    url: '/buCoupon/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加优惠券
 *
 * @author zhangjw
 * @date 2023-06-16 09:50:35
 */
export function buCouponAdd (parameter) {
  return axios({
    url: '/buCoupon/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑优惠券
 *
 * @author zhangjw
 * @date 2023-06-16 09:50:35
 */
export function buCouponEdit (parameter) {
  return axios({
    url: '/buCoupon/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 优惠券详情
 *
 * @author zhangjw
 * @date 2023-06-16 09:50:35
 */
export function buCouponDetail (parameter) {
  return axios({
    url: '/buCoupon/detail',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除优惠券
 *
 * @author zhangjw
 * @date 2023-06-16 09:50:35
 */
export function buCouponDelete (parameter) {
  return axios({
    url: '/buCoupon/delete',
    method: 'get',
    params: parameter
  })
}

/**
 * 导出优惠券
 *
 * @author zhangjw
 * @date 2023-06-16 09:50:35
 */
export function buCouponExport (parameter) {
  return axios({
    url: '/buCoupon/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
